import type { FC } from "react";

import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import { AuthContextProvider } from "./context";
import { TLPCloudForgotPasswordPage } from "./forgotPassword";
import { TLPCloudLoginPage } from "./login";
import { TLPCloudMfaTypePage } from "./mfaType";
import { TLPCloudOTPPage } from "./otp";
import { TLPCloudResetPasswordPage } from "./resetPassword";

export const Auth: FC = () => {
	return (
		<AuthContextProvider>
			<BrowserRouter basename="/MVC/Account">
				<Switch>
					<Route exact path="/" component={TLPCloudLoginPage} />
					<Route exact path="/Login" component={TLPCloudLoginPage} />
					<Route exact path="/MfaType" component={TLPCloudMfaTypePage} />
					<Route exact path="/OTP" component={TLPCloudOTPPage} />
					<Route exact path="/ForgotPassword" component={TLPCloudForgotPasswordPage} />
					<Route exact path="/ResetPassword" component={TLPCloudResetPasswordPage} />
					<Redirect from="*" to="/" />
				</Switch>
			</BrowserRouter>
		</AuthContextProvider>
	);
};
